import http from "./../shared/axios";
import { Telco_Otp_Gen,Telco_Otp_Verify } from "../shared/ServiceCommonEndpoints";
import { getApiSubPayload } from "../shared/utility";
class TelcoService {
  funcSendTelcoOtp(payload) {
    /*const otpInputData = {
      mobile: payload.mobile,
      consent :payload.consent,
      action:action
    };*/
    const telcoOtpRequest = {
      data : payload,
      action:"submit",
      type: "send-telco-otp"
    }
    return http.post(Telco_Otp_Gen, telcoOtpRequest,
      {
        headers: {
          "IDENTIFIER_1": payload.applicationNumber,
          "IDENTIFIER_2": localStorage.getItem("visitorID"),
          "ENCRYPTED_ID": "1"
        }
      });
  }
  funcVerifyOtp(payload) {

    payload = { ...payload, ...getApiSubPayload() };
    const otpInputData = {
      data : payload,
      "action": "submit",
      "type": "verify-telco-otp"
    };
    return http.post(Telco_Otp_Verify, otpInputData,
      {
        headers: {
          "IDENTIFIER_1": payload.applicationNumber,
          "IDENTIFIER_2": localStorage.getItem("visitorID"),
          "DeviceInfo": localStorage.getItem("deviceinfo"),
        }
      });
  }
}
// eslint-disable-next-line
export default new TelcoService();
